import { Component, OnInit } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import{ApiService} from '../../../services/api.service';
import { Router, ActivatedRoute} from '@angular/router';
import { LoadingController } from '@ionic/angular';
import { AlertController } from '@ionic/angular';

@Component({
  selector: 'app-ekskul-setting',
  templateUrl: './ekskul-setting.page.html',
  styleUrls: ['./ekskul-setting.page.scss'],
})
export class EkskulSettingPage implements OnInit {

  constructor(
  	private camera:Camera,
  	private api:ApiService,
  	private route:ActivatedRoute,
  	public loadingController: LoadingController,
  	public alertController: AlertController
  ) { }


  ngOnInit() {
  	var id=this.route.snapshot.paramMap.get('id');
  	this.getData(id);
  }

  ekstra:any={};
  getData(id)
  {
  		this.api.data('ekskul/'+id,'get','').subscribe(data=>{
  			this.ekstra=data;
  		})
  }

  images:any=[];
  getImage(mode)
  {  		
      const options: CameraOptions = {
        quality: 80,
        allowEdit:true,        
        sourceType:mode,
        correctOrientation: true,
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.PNG,
        targetWidth:600,
        targetHeight:400
      };
      this.camera.getPicture(options).then((imageData) => {     
        let base64Image = 'data:image/png;base64,' + imageData;
        this.addImage(base64Image);
      }, (err) => {
          console.log(err);
      });      
  }

  loading:boolean;
  update()
  {
  		this.loading=true;
  		var dat={
  			nama:this.ekstra.nama,
  			deskripsi:this.ekstra.deskripsi
  		};
  		this.api.data('ekskul/'+this.ekstra.id,'put',dat).subscribe(data=>{
  			console.log(data);
  			this.loading=false;
  		})
  }
  loadingImage:boolean;
  addImage(imageData)
  {
  		this.loadingImage=true;   		
  		this.api.data('ekskul/image/'+this.ekstra.id,'put',{imageData:imageData}).subscribe(data=>{
  			this.loadingImage=false;
  			this.ekstra.images.push(imageData);
  		},error=>{
  			this.loadingImage=false;
  			alert(JSON.stringify(error));
  		});
  }
  loadingDel:any={};
  deleteImage(idx)
  { 
  		this.loadingDel[idx]=true; 		
  		this.api.data('ekskul/image/'+this.ekstra.id+'/'+idx,'delete','').subscribe(data=>{
  			this.loadingDel[idx]=false;
  			this.ekstra.images.splice(idx,1);
  		})
  }

   async presentAlertConfirm(idx) {
    const alert = await this.alertController.create({
      header: 'Menghapus Gambar',
      message: 'Anda yakin akan menghapus gambar?',
      buttons: [
        {
          text: 'Batal',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Ya',
          handler: () => {
            this.deleteImage(idx);
          }
        }
      ]
    });
    await alert.present();
  }

}
